import i18next from 'i18next'

export function useI18n() {
  return i18next
}
